import { collection, getDocs, setDoc, updateDoc, doc, deleteDoc, orderBy, query, where } from 'firebase/firestore';
import { db } from '../../firebase_config';
import { MERCHANT_COLLECTION, Merchant } from '../../type';

class MerchantService {
  async getAll(): Promise<Merchant[]> {
    const q = query(collection(db, MERCHANT_COLLECTION), orderBy('merchant_name', 'asc'));
    const snapshot = await getDocs(q);

    const merchants = snapshot.docs.map(doc => ({ 
      ...doc.data(),
      // merchant_id: doc.id 
    } as Merchant));
    return merchants;
  }

  async create(merchant: Merchant): Promise<void> {
    await setDoc(doc(db, MERCHANT_COLLECTION, merchant.merchant_id), merchant);
  }

  async update(merchant_id: string, merchant: Partial<Merchant>): Promise<void> {
    const { merchant_id: _, ...merchantData } = merchant;
    await updateDoc(doc(db, MERCHANT_COLLECTION, merchant_id), merchantData);
  }

  async delete(merchant_id: string): Promise<void> {
    await deleteDoc(doc(db, MERCHANT_COLLECTION, merchant_id));
  }
}

export const merchantService = new MerchantService();